import axios from 'axios';
import { addErrorInterceptors, addRefreshTokenInterceptor, } from './axios-config';
export * from './jwt';
export * from './okta';
export * from './redirect';
export * from './authManager';
export * from './axios-config';
export * from './auth.types';
export function setupAxiosInstance(extraResponseHandlers = []) {
    const axiosInstance = axios.create();
    addRefreshTokenInterceptor(axiosInstance);
    addErrorInterceptors(axiosInstance, [...extraResponseHandlers]);
    return axiosInstance;
}
//# sourceMappingURL=index.js.map